export const routes = {
    "/:taskId/oldPhysiotherapyReferralReport/*": {
        title: "Physiotherapy Referral Report"
    },
    "/:taskId/physiotherapyReferralReport": {
        title: "Physiotherapy Referral Report"
    },
    "/:taskId/oldAmendPhysiotherapyReferralReport/*": {
        title: "Physiotherapy Referral Report"
    },
    "/:taskId/amendPhysiotherapyReferralReport": {
        title: "Physiotherapy Referral Report"
    },
    "/:taskId/oldQAAmendPhysiotherapyReferralReport/*": {
        title: "Physiotherapy Referral Report"
    },
    "/:taskId/qaAmendPhysiotherapyReferralReport": {
        title: "Physiotherapy Referral Report"
    }
};
